import { useQuery } from '@tanstack/react-query'
import { api } from '~/apiClient'
import { useMarketplace } from '../context'

interface SortingOption {
    value: string
    label: string
}

interface FilterSet {
    filters: Record<string, string[]>
    sorting_options: SortingOption[]
}

async function fetchTraitFilters(nftType: string) {
    return await api.get<FilterSet>(`/api/nft/marketplace/filters/${nftType}/`)
}

export function useTraitFilters() {
    const { state } = useMarketplace()
    return useQuery({
        queryKey: ['marketplace', 'filters', state.collection],
        queryFn: () => fetchTraitFilters(state.collection),
        enabled: !!state.collection,
        keepPreviousData: true,
    })
}
